import { Table } from '@tanstack/react-table'

import { Checkbox } from '@/components/shadcn/checkbox'
import { Label } from '@/components/shadcn/label'

import { MessagesStorageStorageDetailItemWorkspace } from './workspaceFilesTableUtils'

type WorkspaceFilesFiltersProps = {
  table: Table<MessagesStorageStorageDetailItemWorkspace>
}

export function WorkspaceFilesFilters({ table }: WorkspaceFilesFiltersProps) {
  const showDirectories = Boolean(table.getColumn('filename')?.getFilterValue())

  return (
    <div className="flex h-9 items-center gap-2 rounded-md border bg-background px-3">
      <Checkbox
        id="show-directories"
        checked={showDirectories}
        onCheckedChange={(checked) => table.getColumn('filename')?.setFilterValue(checked === true)}
      />
      <Label htmlFor="show-directories" className="cursor-pointer text-sm font-normal">
        Show directories
      </Label>
    </div>
  )
}
